import { gql, TypedDocumentNode } from '@common/hooks';
import {
  RejectApprovalChainStepMutationMutationCgResponse,
  RejectApprovalChainStepMutationMutationVariables,
} from '@common/graphql';

export const AcceptApprovalChainStepMutation = gql`
  mutation AcceptApprovalChainStepMutation(
    $approvalChainStepId: ID!
    $worksMembershipId: ID!
  ) {
    acceptApprovalChainStep(
      approvalChainStepId: $approvalChainStepId
      worksMembershipId: $worksMembershipId
    ) {
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
      approvalChainStep {
        id
      }
    }
  }
`;

export const REJECT_APPROVAL_CHAIN_STEP_MUTATION: TypedDocumentNode<
  RejectApprovalChainStepMutationMutationCgResponse,
  RejectApprovalChainStepMutationMutationVariables
> = gql`
  mutation RejectApprovalChainStepMutation(
    $input: RejectApprovalChainStepInput!
  ) {
    rejectApprovalChainStep(input: $input) {
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
      approvalChainStep {
        id
      }
    }
  }
`;
